import React, { useState } from 'react'
// import comafi from '../../imagenes/checkout/payment-options/comafi.png'
//import santaFe from '../../imagenes/checkout/payment-options/santaFe.png'
//import provincia from '../../imagenes/checkout/payment-options/provincia_nuevo.jpg'
//import ahora12 from '../../imagenes/checkout/payment-options/logo_ahora12.jpg'
//import ahora18 from '../../imagenes/checkout/payment-options/logo_ahora18.jpg'
// import ahora3 from '../../imagenes/checkout/payment-options/ahora3.png'
//import ahora6 from '../../imagenes/checkout/payment-options/logo_ahora6.jpg'
import naranja from '../../imagenes/checkout/payment-options/ico-tarjeta_0001_naranja.png'
import cabal from '../../imagenes/checkout/payment-options/ico-tarjeta_0000_cabal.jpg'
import visa from '../../imagenes/checkout/payment-options/ico-tarjeta_0004_visa.jpg'
import master from '../../imagenes/checkout/payment-options/ico-tarjeta_0003_master.jpg'
import american from '../../imagenes/checkout/payment-options/ico-tarjeta_0002_american.jpg'
import { RUTA_IMAGEN } from '../../utils/rutasFijas'
//import americanExpress from '../../imagenes/checkout/payment-options/americanExpress.png'

const PromocionesBancarias = (props) => {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [urlImagen, setUrlImagen] = useState('');
  //detalleVisa.png
  
  const handleClickTarjeta = (nombreUrl) => {
    setUrlImagen(`${RUTA_IMAGEN}bancos/${nombreUrl}`);
    setMostrarModal(true);
  }

  //Hay más bancos comentados debajo del return.
  return (
    <section className="sobre-pedraza">

      <div className="container">
        <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 articulosFijos">
            <h1>Disfrut&aacute; de nuestras promociones</h1>
            <hr />

            <div className="nuevoContenedorPromosBancarias">

              <div className="cuadroTarjeta" onClick={() => handleClickTarjeta('detalle-cabal')}>
                <img src={cabal} alt="Cabal" />

                <p className="textoCuota">Hasta 18 cuotas fijas</p>
                <p className="textoCondiciones">Consulta condiciones vigentes</p>
              </div>

              <div className="cuadroTarjeta" onClick={() =>handleClickTarjeta('detalle-visa')}>
                <img src={visa} alt="Visa" />

                <p className="textoCuota">Hasta 18 cuotas fijas</p>
                <p className="textoCondiciones">Consulta condiciones vigentes</p>
              </div>

              <div className="cuadroTarjeta" onClick={() =>handleClickTarjeta('detalle-american')}>
                <img src={american} alt="American Express" />

                <p className="textoCuota">Hasta 18 cuotas fijas</p>
                <p className="textoCondiciones">Consulta condiciones vigentes</p>
              </div>

              <div className="cuadroTarjeta" onClick={() =>handleClickTarjeta('detalle-master')}>
                <img src={master} alt="Mastercad" />

                <p className="textoCuota">Hasta 18 cuotas fijas</p>
                <p className="textoCondiciones">Consulta condiciones vigentes</p>
              </div>

              <div className="cuadroTarjeta" onClick={() =>handleClickTarjeta('detalle-naranja')}>
                <img src={naranja} alt="Tarjeta Naranja" />

                <p className="textoCuota">Plan Z</p>
                <p className="textoCondiciones">Consulta condiciones vigentes</p>
              </div>

            </div>
	{/*
            <div className="contenedorPromosBancarias">

		
				<div className="info_bancos">
					<img src={comafi} alt="Banco Comafi"/>

					<p>
					  Promociones válidas desde el 20/11/2018 al 31/01/2020 todos los días abonando en 3 cuotas con tarjetas de crédito Visa, MasterCard y Diners Banco Comafi para compras realizadas por venta telefónica o en puntos de venta propios de Pedraza (no incluidas Provencred y Mastercard Dinosaurio). No acumulable con otras promociones. Consultar sucursales adheridas en www.tevabien.com
					  <span> TNA: 0,00%; TEA: 0,00%; CFT: 3,89%.</span>
					</p>
				</div>

				<div className="info_bancos">
					<img src={ahora3} alt="Ahora 3"/>

					<p>
					  Financiación Ahora 3 Exclusiva para tarjetas de crédito AMEX, VISA, Mastercard y Cabal. A través del programa se podrá comprar solo en 3 cuotas. No podrán realizarse compras por menor cantidad de cuotas, es decir, el financiamiento NO es hasta 3 cuotas, sino en 3 cuotas.
					  <span> CFT 20,30% - TNA 15,33%.</span>
					</p>
				</div>
			


              <div className="info_bancos" onClick={() => setMostrarModal(true)}>
                <img src={ahora6} alt="Ahora 6" />

                <p>
                  Financiación Ahora 6 Exclusiva para tarjetas de crédito AMEX, VISA, Mastercard y Cabal. A través del programa se podrá comprar solo en 6 cuotas. No podrán realizarse compras por menor cantidad de cuotas, es decir, el financiamiento NO es hasta 6 cuotas, sino en 6 cuotas.
                  <span> CFT 23,11% - TNA 17,19%.</span>
                </p>
              </div>

              <div className="info_bancos">
                <img src={ahora12} alt="Ahora 12"/>

                <p>Financiación Ahora 12 Exclusiva para tarjetas de crédito AMEX, VISA, Mastercard y Cabal.
                  A través del programa se podrá comprar solo en 12 cuotas. No podrán realizarse compras por menor cantidad de cuotas, es decir, el financiamiento NO es hasta 12 cuotas, sino en 12 cuotas.
                  <span>CFT 25,06% - TNA 18,37%.</span>
                </p>
            </div>
            <div className="info_bancos">
              <img src={ahora18} alt="Ahora 18"/>

              <p>Financiación Ahora 18 Exclusiva para tarjetas de crédito AMEX, VISA, Mastercard y Cabal.
                A través del programa se podrá comprar solo en 18 cuotas. No podrán realizarse compras por menor cantidad de cuotas, es decir, el financiamiento NO es hasta 18 cuotas, sino en 18 cuotas.
                <span>CFT 25,89% - TNA 18,78%.</span>
              </p>
            </div>
         
          </div>
        */}
        </article>
        </div>
      </div>


            <div 
              className="modal" 
              style={{display: mostrarModal ? 'block' : 'none', backgroundColor: '#8a8a8a80'}} 
              onClick={() => setMostrarModal(false)}
              tabIndex="-1" 
              role="dialog" 
              aria-labelledby="exampleModalCenterTitle" 
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered " role="document">
                <div className="modal-content" >
                  <div className="modal-header">
                    <h5 className="modal-title">Información</h5>
                    <button type="button" onClick={() => setMostrarModal(false)} style={{'color':'#fff', 'opacity':'1', 'textShadow':'none' }} className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body" style={{textAlign: 'center'}}>
                      <img src={`${urlImagen}.jpg`} 
                      srcSet={`${urlImagen}-mob.jpg 600w,
                              ${urlImagen}.jpg 163w`}
                      sizes="(max-width: 700px) 600px, 163px" alt="Detalle de la tarjeta" />
                    </div>
                </div>
              </div>
            </div>
    </section>
  )

//  <div className="info_bancos">style={{minWidth: '850px'}}
//    <img src={provincia} alt="Banco Provincia"/>
//    <div><strong>Promoción válida solo para destinos nacionales</strong></div>
//    <p><strong>Beneficio público en general</strong></p>
//    <p><span>Costo Financiero Total Efectivo Anual (CFTEA) 0,00%. Interés: Tasa Nominal Anual Vencida (T.N.A.V.) 0,00%. Tasa Efectiva Anual Vencida (T.E.A.V.) 0,00% </span>. HASTA 9 CUOTAS SIN INTERÉS. Promoción válida para todos los destinos nacionales. Promoción válida todos los días desde el 06/05/2019 hasta el 29/02/2020 inclusive para la contratación de viajes y paquetes turísticos a través de PEDRAZA VIAJES Y TURISMO, con las tarjetas de Crédito Visa y/o Mastercard emitidas por el Banco Provincia. Se excluyen de la promoción las tarjetas Visa Regalo, Visa Recargable, Visa Business, Visa Corporate y Visa Purchasing. No acumulable con otras promociones y/o descuentos vigentes. Ejemplo representativo: En una compra con tarjeta de crédito de $ 4.500.- en 9 cuotas sin interés, el cliente abonará 9 cuotas de $ 500.- cada una. El descuento promocionado aplicará sobre el precio contado en concordancia Resolución 51 y 240 - E/ 2017 Ministerio de Producción de la Nación, Secretaría de //Comercio. Conservar ticket. Banco de la Provincia de Buenos Aires. CUIT 33-99924210-9. Calle 7 n° 726, La Plata, Provincia de Buenos Aires. www.bancoprovincia.com.ar. <b>Cartera de consumo.</b></p>
//  </div>


  //PROVINCIA
  // <div className="info_bancos">
  //   <img src={provincia} alt="Banco Provincia"/>
  //   <div><strong>Promoción válida solo para destinos nacionales</strong></div>
  //   <p><strong>Beneficio público en general</strong></p>
  //   <p><span>Costo Financiero Total Efectivo Anual (CFTEA) 0,00%. Interés: Tasa Nominal Anual Vencida (T.N.A.V.) 0,00%. Tasa Efectiva Anual Vencida (T.E.A.V.) 0,00% </span>. HASTA 9 CUOTAS SIN INTERÉS. Promoción válida para todos los destinos nacionales. Promoción válida todos los días desde el 01/02/2019 hasta el 31/03/2019 inclusive para la contratación de viajes y paquetes turísticos a través de PEDRAZA VIAJES Y TURISMO, con las tarjetas de Crédito Visa y/o Mastercard emitidas por el Banco Provincia. Se excluyen de la promoción las tarjetas Visa Regalo, Visa Recargable, Visa Business, Visa Corporate y Visa Purchasing. No acumulable con otras promociones y/o descuentos vigentes. Ejemplo representativo: En una compra con tarjeta de crédito de $ 4.500.- en 9 cuotas sin interés, el cliente abonará 9 cuotas de $ 500.- cada una. El descuento promocionado aplicará sobre el precio contado en concordancia Resolución 51 y 240 - E/ 2017 Ministerio de Producción de la Nación, Secretaría de Comercio. Conservar ticket. Banco de la Provincia de Buenos Aires. CUIT 33-99924210-9. Calle 7 n° 726, La Plata, Provincia de Buenos Aires. www.bancoprovincia.com.ar. <b>Cartera de consumo.</b></p>
  //
  //   <p><strong>Beneficio exclusivo jubilados y pensionados</strong></p>
  //   <p><span>Costo Financiero Total Efectivo Anual (CFTEA) 0,00%. Interés: Tasa Nominal Anual Vencida (T.N.A.V.) 0,00%. Tasa Efectiva Anual Vencida (T.E.A.V.) 0,00% </span>. HASTA 12 CUOTAS SIN INTERÉS. Promoción válida para todos los destinos nacionales. Promoción válida para Jubilados y Pensionados, todos los días desde el 01/02/2019 hasta el 31/03/2019 inclusive para la contratación de viajes y paquetes turísticos a través de PEDRAZA VIAJES Y TURISMO, con las tarjetas de Crédito Visa y/o Mastercard emitidas por el Banco Provincia. Se excluyen de la promoción las tarjetas Visa Regalo, Visa Recargable, Visa Business, Visa Corporate y Visa Purchasing. No acumulable con otras promociones y/o descuentos vigentes. Ejemplo representativo: En una compra con tarjeta de crédito de $ 1.200.- en 12 cuotas sin interés, el cliente abonará 12 cuotas de $ 100.- cada una. El descuento promocionado aplicará sobre el precio contado en concordancia Resolución 51 y 240 - E/ 2017 Ministerio de Producción de la Nación, Secretaría de Comercio. Conservar ticket. Banco de la Provincia de Buenos Aires. CUIT 33-99924210-9. Calle 7 n° 726, La Plata, Provincia de Buenos Aires. www.bancoprovincia.com.ar. <b>Cartera de consumo.</b></p>
  // </div>

  //AMERICAN EXPRESS
  // <div className="info_bancos">
  //     <img src={americanExpress} alt="American Express"/>
  //
  //     <p><span>Costo Financiero Total Efectivo Anual (CFTEA) 0,00%. Interés: Tasa Nominal Anual Vencida (TNAV) 0,00%. Tasa Efectiva Anual Vencida (TEAV) 0,00%.</span> HASTA 6 CUOTAS SIN INTERÉS. Promoción válida para todos los destinos. Promoción válida todos los días desde el 03/01/2019 hasta el 03/04/2019 inclusive para la contratación de viajes y paquetes turísticos a través de PEDRAZA VIAJES Y TURISMO, Casa Central y Sucursal La Plata. No acumulable con otras promociones y/o descuentos vigentes. Ejemplo representativo: En una compra con tarjeta de crédito de $ 6000.- en 6 cuotas sin interés, el cliente abonará 6 cuotas de $ 1000.- cada una.</p>
  // </div>

    // <div className="container">
    //     <div className="row">
    //           <div style={{width: '25vw', height: '25vh', border:'1px solid black', margin: '1vw'}}><img style={{borderRadius: '20%'}} src={americanExpress}/></div>
    //           <div style={{width: '25vw', height: '25vh', border:'1px solid black', margin: '1vw'}}></div>
    //           <div style={{width: '25vw', height: '25vh', border:'1px solid black', margin: '1vw'}}></div>
    //     </div>
    //     <div className="row">
    //           <div style={{width: '25vw', height: '25vh', border:'1px solid black', margin: '1vw'}}></div>
    //           <div style={{width: '25vw', height: '25vh', border:'1px solid black', margin: '1vw'}}></div>
    //           <div style={{width: '25vw', height: '25vh', border:'1px solid black', margin: '1vw'}}></div>
    //     </div>
    // </div>
}

export default PromocionesBancarias



// WEBPACK FOOTER //
// ./src/components/Global/PromocionesBancarias.js